import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Tag } from "../../utils/GTMPageTag";
import FAQ from "../../components/faq/FAQ";
import "./FAQ.scss";

const FaqPage = () => {
    Tag("OrderMailbox")
    return (
        <div id="FAQ" className="MainbBody">
            <div className="FaqBanner">
                <Container>
                <Row>
                    <Col sm={12}>
                        <h3>
                            Häufig gestellte Fragen (FAQ)
                        </h3>
                        <p>CleverDomizil Geschäftsadressen & Services</p>
                    </Col>
                </Row>
                </Container>
            </div>
            <div className="FaqBody">
                    <Container>
                    <Row>
                        <Col sm={12}>
                            <FAQ className="light-bg" />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default FaqPage;